export default __webpack_public_path__ + "static/media/Ceprocon-500-eng.ddaa26cc.jpg";